export const AutomationOption = {
  GoogleHome: 'GoogleHome',
  AppleHomeKit: 'AppleHome',
  AmazonAlexa: 'AmazonAlexa',
}

export const CallName = {
  Siri: 'Siri',
  Alexa: 'Alexa',
  HeyGoogle: 'Hey Google',
}

export const Standard = {
  KNX: 'KNX',
  Loxone: 'Loxone',
}
